import { createFileRoute } from '@tanstack/react-router'
import { CompareIndexPage } from '../components/pages'
import { CatalogProvider } from '../content/catalog-context'
import { loadPageData } from '../content/page-data-fn'
import { staticRouteHead } from '../lib/seo'

export const Route = createFileRoute('/it/confronta/')({
  loader: () => loadPageData({ data: { kind: 'compare', locale: 'it' } }),
  head: () => staticRouteHead('compare', 'it'),
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <CatalogProvider snapshot={Route.useLoaderData().snapshot}>
      <CompareIndexPage />
    </CatalogProvider>
  )
}
